import { Pipe, PipeTransform } from '@angular/core';
import {DateTimeService} from '../date-time.service';

@Pipe({
  name: 'brdatetime'
})
export class BrDatetimePipe implements PipeTransform {

  constructor(private dateTimeService: DateTimeService) {
  }

  transform(givenDateTime: Date, complete: boolean = false): string {
    if (!givenDateTime) return null;
    return this.dateTimeService.formatBrDateTime(givenDateTime, complete);
  }
}
